import 'reflect-metadata'
import '@rdss/elements'
import { Build } from '@stencil/core'
import { ApiClient } from '@rdss/client'

/**
 * This function creates a new instance of the ApiClient.
 */
const connectApiClient = () => {
    /**
     * Creates the authorization header for basic authentication with encrypted credentials.
     */
    const createBasicAuthString = () => {
        if (!(process.env.basic_auth_user && process.env.basic_auth_password)) return

        return 'Basic ' + Buffer
            .from(`${process.env.basic_auth_user}:${process.env.basic_auth_password}`, 'utf8')
            .toString('base64')
    }

    /**
     * Creates the session cookie object with session name and session value for the logged in user.
     */
    const createSessionCookie = () => {
        return {
            name: process.env.session_cookie_name,
            value: process.env.session_cookie_value,
        }
    }

    ApiClient.create({
        platform: Build,
        auth: Build.isServer ? createBasicAuthString() : null,
        host: Build.isServer
            ? process.env.RDSS_UI_API_HOST
            : location.host,
        session: Build.isServer ? createSessionCookie() : null,
    })
}

/**
 * The purpose of this function is to set up and
 * initialize the application.
 */
export default () => {
    connectApiClient()
}
